import React from 'react';

export function Discover(): JSX.Element {
  return (
    <svg width="40" height="26" viewBox="0 0 40 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.8105 22.75C39.8105 24.5364 38.3247 26 36.5085 26H3.49334C1.67712 26 0.191406 24.5364 0.191406 22.75V3.25C0.191406 1.4625 1.67712 0 3.49334 0H36.5085C38.3247 0 39.8105 1.4625 39.8105 3.25V22.75Z"
        fill="#113152"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="18"
        y="10"
        width="6"
        height="6">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2324 13.2135C18.2324 14.5684 19.2746 15.5816 20.6642 15.5816C22.0188 15.5816 23.0882 14.5553 23.0882 13.2429C23.0872 11.9325 22.0256 10.9082 20.6642 10.9082C19.3223 10.9082 18.2324 11.9405 18.2324 13.2135Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2324 13.2135C18.2324 14.5684 19.2746 15.5816 20.6642 15.5816C22.0188 15.5816 23.0882 14.5553 23.0882 13.2429C23.0872 11.9325 22.0256 10.9082 20.6642 10.9082C19.3223 10.9082 18.2324 11.9405 18.2324 13.2135Z"
          fill="url(#paint0_linear)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.27002 13.2081C8.27002 13.6449 8.08513 14.0776 7.77374 14.3506C7.49057 14.6014 7.12468 14.7106 6.54471 14.7106H6.30339V11.7126H6.54569C7.12468 11.7126 7.47694 11.8148 7.77374 12.0797C8.08513 12.3517 8.27002 12.7733 8.27002 13.2081ZM9.19647 13.2152C9.19647 11.8765 8.18056 10.9453 6.72383 10.9453H5.40625V15.4791H6.71604C7.41473 15.4791 7.91879 15.3153 8.36058 14.9553C8.88508 14.5287 9.19647 13.8815 9.19647 13.2152ZM9.61063 15.4791H10.5069V10.9453H9.61063V15.4791ZM12.4404 15.5878C11.7563 15.5878 11.2591 15.3229 10.8455 14.7243L11.4255 14.1743C11.6318 14.5686 11.9782 14.7789 12.4044 14.7789C12.8063 14.7789 13.1021 14.5069 13.1021 14.1399C13.1021 13.9488 13.0136 13.787 12.8345 13.6708C12.744 13.6162 12.565 13.5332 12.2127 13.4129C11.371 13.1136 11.081 12.7951 11.081 12.1703C11.081 11.4291 11.7028 10.871 12.5163 10.871C13.0204 10.871 13.4836 11.0409 13.8699 11.3745L13.3999 11.9792C13.1644 11.7203 12.9454 11.6121 12.6749 11.6121C12.2896 11.6121 12.0044 11.8305 12.0044 12.1147C12.0044 12.3593 12.165 12.4888 12.7031 12.6849C13.7249 13.054 14.0285 13.3796 14.0285 14.0995C14.0285 14.9751 13.3726 15.5878 12.4404 15.5878ZM16.7426 15.5808C15.3744 15.5808 14.3118 14.5465 14.3118 13.2148C14.3118 11.8974 15.4036 10.8428 16.763 10.8428C17.1493 10.8428 17.4734 10.9237 17.8675 11.1218V12.1623C17.4938 11.8003 17.1698 11.6517 16.7426 11.6517C15.8989 11.6517 15.2362 12.3382 15.2362 13.2078C15.2362 14.1248 15.8785 14.7709 16.7834 14.7709C17.1902 14.7709 17.5074 14.6274 17.8675 14.2745V15.3149C17.4607 15.505 17.1289 15.5808 16.7426 15.5808ZM25.3718 15.5944H24.8892L22.9352 10.9453H23.9151L25.1431 13.9897L26.3868 10.9453H27.3608L25.3718 15.5944ZM27.7688 15.4791V10.9453H30.3154V11.7127H28.666V12.7198H30.2531V13.4872H28.666V14.7107H30.3154V15.4791H27.7688ZM32.9473 12.3315C32.9473 12.7865 32.6417 13.0312 32.0705 13.0312H31.8087V11.6581H32.0841C32.6417 11.6591 32.9473 11.8896 32.9473 12.3315ZM34.2737 15.4791L32.8228 13.5681C33.4991 13.4336 33.8727 12.9766 33.8727 12.285C33.8727 11.4336 33.2811 10.9453 32.2438 10.9453H30.9116V15.4791H31.8098V13.6571H31.9275L33.1702 15.4791H34.2737Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5019 13.4866C18.5019 12.2126 19.5918 11.1802 20.9347 11.1802C21.5526 11.1802 22.1082 11.3926 22.5315 11.7444C22.0917 11.2308 21.4212 10.9072 20.6564 10.9072C19.3145 10.9072 18.2246 11.9406 18.2246 13.2126C18.2246 13.9577 18.5399 14.5988 19.0537 15.0245C18.7063 14.618 18.5019 14.0862 18.5019 13.4866Z"
        fill="#B74511"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.6687 25.9974C38.4118 25.9149 39.8115 24.4851 39.8115 22.7512V15.4336C37.6195 16.8014 26.9002 23.026 8.95312 25.9974H36.6687Z"
        fill="#F08D42"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="17.3818"
          y1="12.9955"
          x2="20.2457"
          y2="16.6548"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#ED6C22" />
          <stop offset="1" stopColor="#FEB136" />
        </linearGradient>
      </defs>
    </svg>
  );
}
